import { render, staticRenderFns } from "./VHomeImgJumbo.vue?vue&type=template&id=3a8a464a&scoped=true&"
import script from "./VHomeImgJumbo.vue?vue&type=script&lang=js&"
export * from "./VHomeImgJumbo.vue?vue&type=script&lang=js&"
import style0 from "./VHomeImgJumbo.vue?vue&type=style&index=0&id=3a8a464a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a464a",
  null
  
)

export default component.exports